import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ProductCardPhotoSliderDotsItem = t0 => {
  const $ = _c(5);
  const {
    isActive
  } = t0;
  const t1 = !isActive;
  let t2;
  if ($[0] !== isActive || $[1] !== t1) {
    t2 = classNames("rounded-full h-1.5 w-1.5 m-1 inline-block transition-all duration-700 ease-out [box-shadow:0_0_0_1px_rgba(255,255,255,0.3)]", {
      "opacity-80 bg-gray-light4": t1,
      "opacity-100 bg-gray-light2": isActive
    });
    $[0] = isActive;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
ProductCardPhotoSliderDotsItem.propTypes = {
  isActive: PropTypes.bool
};
const ProductCardPhotoSliderDots = t0 => {
  const $ = _c(7);
  const {
    activeItem: t1,
    itemsCount: t2
  } = t0;
  const activeItem = t1 === undefined ? 0 : t1;
  const itemsCount = t2 === undefined ? 2 : t2;
  let t3;
  if ($[0] !== activeItem || $[1] !== itemsCount) {
    let t4;
    if ($[3] !== activeItem) {
      t4 = itemNumber_0 => <ProductCardPhotoSliderDotsItem key={itemNumber_0} isActive={activeItem === itemNumber_0} />;
      $[3] = activeItem;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t3 = Array(itemsCount).fill(itemsCount).map(_temp).map(t4);
    $[0] = activeItem;
    $[1] = itemsCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="absolute bottom-2 left-0 right-0 flex items-center justify-center pointer-events-none">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
ProductCardPhotoSliderDots.propTypes = {
  activeItem: PropTypes.number,
  itemsCount: PropTypes.number
};
export default ProductCardPhotoSliderDots;
function _temp(_, itemNumber) {
  return itemNumber;
}